import { PageProps } from "@/getServerSideProps/getServerSideProps";
import { Slot } from "../Slot/Slot";
import styles from "./SingleColumn.module.scss";
import classNames from "classnames/bind";
import useRouteLoading from "../../hooks/useRouteLoading";

const cx = classNames.bind(styles);

export const slotNameMap = {
  HEADER: "header",
  TOP: "top",
  PRE_MAIN: "pre-main",
  MAIN: "main",
  FOOTER: "footer",
} as const;

export function SingleColumn(props: PageProps) {
  const isRouteLoading = useRouteLoading();

  return (
    <div data-layout="SingleColumn" className={styles.page}>
      <Slot {...props} name={slotNameMap["HEADER"]} />
      <main className={cx("main")} id="main">
        <div className={styles.grid}>
          <Slot {...props} name={slotNameMap["TOP"]} className={styles.top} />
          <div className={styles.content}>
            <Slot {...props} name={slotNameMap["PRE_MAIN"]} />
            <Slot
              {...props}
              name={slotNameMap["MAIN"]}
              className={cx("mainSlot", {
                "u-loading": isRouteLoading,
              })}
            />
          </div>
        </div>
      </main>
      <Slot {...props} name={slotNameMap["FOOTER"]} />
    </div>
  );
}
